import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'kindOfProperty';

export interface FormValues {
  kindOfProperty: number | null;
}

export const validation = yup.object().shape({
  kindOfProperty: yup
    .number()
    .nullable()
    .required('Please, select an option'),
});
